import { AlertTriangle, CheckCircle, XCircle } from 'lucide-react';

import { useToast } from '@/hooks/use-toast';

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/toast';

export function Toaster() {
  const { toasts } = useToast()

  const getToastIcon = (variant?: string | null) => {
    switch (variant) {
      case 'error':
        return <XCircle className="h-4 w-4 stroke-white" />
      case 'success':
        return <CheckCircle className="h-4 w-4 stroke-white" />
      case 'dark':
        return <CheckCircle className="h-4 w-4 stroke-white" />
      case 'warning':
        return <AlertTriangle className="h-4 w-4 text-amber-600" />
      case 'default':
      default:
        return <CheckCircle className="h-4 w-4" />
    }
  }

  return (
    <ToastProvider duration={3000}>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        return (
          <Toast key={id} variant={variant} duration={3000} {...props}>
            <div className="flex items-center gap-3">
              {getToastIcon(variant)}
              <div className="grid gap-1 flex-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
